import React, { useState } from 'react';
import './Screenshots.css';

const Screenshots = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const screenshots = [
    { src: '/screenshots/login-1.PNG', title: 'Écran de connexion' },
    { src: '/screenshots/home-1.PNG', title: 'Écran d\'accueil' },
    { src: '/screenshots/home-2.PNG', title: 'Écran d\'accueil - Actions' },
    { src: '/screenshots/topup-1.PNG', title: 'Recharge Orange Money' },
    { src: '/screenshots/topup-2.PNG', title: 'Recharge Sama Money' },
    { src: '/screenshots/cards-1.PNG', title: 'Liste des cartes' },
    { src: '/screenshots/cards-2.PNG', title: 'Détails de carte' },
    { src: '/screenshots/cards-3.PNG', title: 'Transactions de carte' },
    { src: '/screenshots/transaction-1.PNG', title: 'Historique des transactions' },
    { src: '/screenshots/reset-1.PNG', title: 'Réinitialisation du mot de passe' },
    { src: '/screenshots/reset-2.PNG', title: 'Nouveau mot de passe' },
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <section id="screenshots" className="screenshots">
      <div className="container">
        <h2 className="section-title">Captures d'écran</h2>
        <p className="section-subtitle">
          Découvrez l'interface de Shini Pay
        </p>
        <div className="screenshots-grid">
          {screenshots.map((screenshot, index) => (
            <div
              key={index}
              className="screenshot-item"
              onClick={() => openModal(screenshot)}
            >
              <img
                src={screenshot.src}
                alt={screenshot.title}
                className="screenshot-thumbnail"
              />
              <div className="screenshot-overlay">
                <span className="screenshot-title">{screenshot.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {selectedImage && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="modal-image"
            />
            <p className="modal-title">{selectedImage.title}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Screenshots;

